import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { User, Users } from 'lucide-react';
import { API } from '../../shared/config';
import { useAuth } from '../../contexts/AuthContext';
import { peutBasculerPerimetre } from '../../lib/droits';

// Bouton « Perso / Tout le monde » : bascule entre ses propres dossiers et ceux de tout le monde.
// Visible pour le Directeur ou si la fonctionnalité « bascule_perso_total » lui a été accordée.
export const VuePerimetreToggle = ({ onChange, className = '' }) => {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!peutBasculerPerimetre(user)) return null;
  const mode = user.vue_perimetre === 'perso' ? 'perso' : 'total';

  const choisir = async (m) => {
    if (m === mode || busy) return;
    setBusy(true);
    try {
      await axios.put(`${API}/users/me/vue-perimetre`, { mode: m });
      setUser(prev => (prev ? { ...prev, vue_perimetre: m } : prev));
      toast.success(m === 'perso' ? 'Vue Perso : uniquement vos données' : 'Vue Tout le monde');
      onChange?.(m);
      setTimeout(() => window.location.reload(), 350);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Impossible de changer la vue');
    } finally {
      setBusy(false);
    }
  };

  const Seg = ({ id, label, Icon }) => {
    const on = mode === id;
    return (
      <button
        type="button"
        onClick={() => choisir(id)}
        disabled={busy}
        aria-pressed={on}
        data-testid={`vue-perimetre-${id}`}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 ${
          on ? (id === 'perso' ? 'bg-[#1173D4] text-white shadow' : 'bg-slate-800 text-white shadow') : 'text-slate-600 hover:text-slate-900 hover:bg-white/70'
        }`}
      >
        <Icon className="h-3.5 w-3.5" />
        {label}
      </button>
    );
  };

  return (
    <div
      className={`inline-flex items-center gap-0.5 p-1 rounded-full bg-slate-100 border border-slate-200 shadow-inner select-none ${className}`}
      title="Choisir entre vos dossiers uniquement ou ceux de tout le monde"
      data-testid="vue-perimetre-toggle"
    >
      <Seg id="perso" label="Perso" Icon={User} />
      <Seg id="total" label="Tout le monde" Icon={Users} />
    </div>
  );
};

export default VuePerimetreToggle;
